import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { isScreenBelow1280 } from 'store/common/settings/breakpoint/selectors';
import {
  requestFancyNumbers,
  changeFancyNumber,
  toggleFancyNumber,
} from 'store/ProductDetails/common/actions';
import { getActiveFancyNumber, getFancyNumbersLoading } from 'store/ProductDetails/selectors';
import { Preloader } from 'components';

import styles from './styles.pcss';
import { FancyNumbersLayout } from '../../../../components';

const cx = classNames.bind(styles);

class FancyNumbersContainer extends React.Component {
  componentDidMount() {
    this.props.onLoad();
  }

  render() {
    const { isLoading, onLoad, uploadDataOnly, ...layoutProps } = this.props;
    return (
      !uploadDataOnly &&
      (isLoading ?
        <div className={cx('preloaderWrapper')}>
          <Preloader />
        </div>
      : <FancyNumbersLayout {...layoutProps} />)
    );
  }
}

FancyNumbersContainer.propTypes = {
  isLoading: PropTypes.bool,
  uploadDataOnly: PropTypes.bool,
  onLoad: PropTypes.func,
  /**
   * Layout props
   */
  categoryText: PropTypes.string,
  inlineStyle: PropTypes.bool,
};

FancyNumbersContainer.defaultProps = {
  uploadDataOnly: false,
};

const mapStateToProps = (state) => ({
  isMobile: isScreenBelow1280(state),
  activeNumber: getActiveFancyNumber(state),
  isLoading: getFancyNumbersLoading(state),
});

const mapDispatchToProps = {
  onLoad: requestFancyNumbers,
  changeNumber: changeFancyNumber,
  toggleNumber: toggleFancyNumber,
};

const FancyNumbers = connect(mapStateToProps, mapDispatchToProps)(FancyNumbersContainer);

export default FancyNumbers;
